// extracted by mini-css-extract-plugin
module.exports = {"container":"registration-success_container__3xT5x","centered":"registration-success_centered__3d2-T","text":"registration-success_text__1aNtP"};